import { render, staticRenderFns } from "./NewStoreLayout.vue?vue&type=template&id=a3535d0c&scoped=true"
import script from "./NewStoreLayout.vue?vue&type=script&lang=js"
export * from "./NewStoreLayout.vue?vue&type=script&lang=js"
import style0 from "./NewStoreLayout.vue?vue&type=style&index=0&id=a3535d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3535d0c",
  null
  
)

export default component.exports